import { Component, Input, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { getSelectedStoreLocation } from "src/app/shared/ui/locationstate/location.selectors";
import { AppState } from "src/app/store/app.state";
import { CookieService } from "ngx-cookie-service";
@Component({
  selector: "app-transaction-summary-shared",
  templateUrl: "./transaction-summary-shared.component.html",
  styleUrls: ["./transaction-summary-shared.component.scss"],
})
export class TransactionSummarySharedComponent implements OnInit {
  @Input() summary: any;
  @Input() transactions: any;
  @Input() transactionType: any;
  //@Input() currency: any
  currency$: any  = this.cookieService.get("currency");
  currencyWidth: string = (this.currency$ === '$' || this.currency$ === '₱' || this.currency$ === '₹' || this.currency$ === '£') ? '20px' : '42px';
  taxAliasValue: string = this.cookieService.get("taxAliasValue");
  constructor(private store: Store<AppState>, private cookieService: CookieService) {}
  ngOnInit(): void {

    if (!Boolean(this.currency$)) {
      this.currency$ = "$";
    }
    // this.store.select(getSelectedStoreLocation).subscribe((result) => {
    //   // console.log("TOTAL_RESULTS_SUMMARY", result)
    //   // this.currency$ = result.currency === "" ? "$" : result.currency;
    //   this.currency$ = result.currency && result.currency;
    // });


  }
  increaseCloseTransaction() {
    this.summary.closedTransactions = this.summary.closedTransactions + 1;
  }

  checkNegative(num: any) {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  }

  checkZeroInc(num: any) {
    if (Math.abs(num) === 0) {
      return true
    }
    return false
  }
  showPlusData(num) {
    return '+' + num;
  }

  netSaleDataTotal: any = {
    value1: 0.00,
    value2: 0.00,
    percentage: 0.00
  };
}
